import { jwtDecode } from "jwt-decode";
import React from "react";
import { Route, Navigate } from "react-router-dom";

const PrivateRoutes = ({ element: Element, ...rest }) => {
  const token = localStorage.getItem("admintoken");
  if (!token) {
    return <Navigate to="/404" />;
  }
  const decodedToken = jwtDecode(token);
  const userRole = decodedToken.role;
  console.log(userRole);
  return userRole === "superadmin" ? (
    <Element {...rest} />
  ) : (
    <Navigate to="/404" />
  );};

export default PrivateRoutes;
